import React, { useState } from 'react';

import ProfileModal from './ProfileModal';

const ArtistCard = ({jsonData}) => {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  const openProfileModal = () => {
    setIsProfileModalOpen(true);
  };

  const closeProfileModal = () => {
    setIsProfileModalOpen(false);
  };

  return (
    <div>
      <div className='center-div'>
        <img src={jsonData['file-name']} onClick={openProfileModal} alt='' style={{width:'min(450px,100%)'}}></img>
      </div>
      <div style={{ height: '50px', width: '1px' }}></div>
      <div className='center-div artist-name-margin'>
        <span className='default-text'>{jsonData['name']}</span>
        <span style={{width: '0.5rem'}}></span>
        <span className='default-text grey-text'>{jsonData['id'].join(' ')}</span>
      </div>
      <ProfileModal isOpen={isProfileModalOpen} onRequestClose={closeProfileModal} data={jsonData} />
    </div>
  );
}

export default ArtistCard;
